
import TheSalonList from "./components/salon-list/TheSalonList.vue";
import SearchResult from "./components/map/SearchResult.vue";
import dummy from "./data/dummy";
import Salon from "./models/Salon";
import FIcon from '@fixit/icons/src/components/FIcon.vue';
import { sortSalonListByUserLocation } from '@fixit/fixit-no-header/src/utils/location'

export default {
  props: {
    salons: {
      type: Array,
      required: false,
    },
    title: {
      type: String, 
      required: false,
      default: 'Andre avdelinger'
    },
    isLandingPage: {
      type: Boolean,
      required: false,
      default: false,
    },
    showMap: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  components: {
    TheSalonList,
    SearchResult,
    FIcon,
  }, 
  computed: {
    dummySalons()  {
      return dummy.dummySalons.map(x => new Salon(x))
    },
    mappedSalons () {
      if (this.salons === undefined || this.salons === null) {
        return this.dummySalons
      }
      if (this.salons.length <= 0) {
        return this.dummySalons
      }
      if (this.isLandingPage && this.salons.length > 4) return this.salons.slice(0, 4)
      else return this.salons.map(x => new Salon(x))
    }
  },
  methods: {
    scrollToMap() {
      const element = document.getElementById("salons-map");
      element.scrollIntoView({behavior: "smooth", block: "end"});
    }
  },
  async mounted() {
    this.isMounted = true;
    //Sort the salon list if the user accepts/has accepted sharing location.
    if (this.salons.length > 1) await sortSalonListByUserLocation(this, this.salons);
  },
  data() {
    return {
      isMounted: false,
      state: {
        SALONS: "salons",
        MAP: "map",
      },
      current: "salons",
    };
  },
};
